import styled from 'styled-components';

export const UserContainer = styled.div`
  display: flex;
  align-items: center;
  cursor: pointer;

  > div {
    display: flex;
    align-items: flex-end;
  }
`;

export const Main = styled.div`
  width: 100%;
  display: flex;
  justify-content: end;
  background: white;
`;

export const ToolsContainer = styled.div`
  flex-direction: column;
  p {
    margin: 0px;

    color: var(--text-secondary, #808080);
    /* Text/M */
    font-family: Roboto;
    font-size: 14px;
    font-style: normal;
    font-weight: 300;
    line-height: 20px; /* 142.857% */
    letter-spacing: 0.28px;
  }
`; 